import React from "react";
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from "@chakra-ui/react";
import { FormikErrors, FormikTouched } from "formik";
import { Mail, Smartphone } from "lucide-react";
import whatsappBlue from "../../../../assets/whatsapp-blue.svg";
import { CustomCheckboxCard } from "./CustomCheckboxCard";
import { AlertChannel, EditAlertFormValues } from "../../../Alert/types";

interface AlertDeliveryChannelProps {
  t: (key: string) => string;
  values: {
    channels?: AlertChannel[];
  };
  setFieldValue: (field: string, value: any) => void;
  errors?: FormikErrors<EditAlertFormValues>;
  touched?: FormikTouched<EditAlertFormValues>;
}

export const AlertDeliveryChannel: React.FC<AlertDeliveryChannelProps> = ({
  t,
  values,
  setFieldValue,
  errors,
  touched,
}) => {
  const handleChannelToggle = (channel: AlertChannel) => {
    const currentChannels = values.channels || [];

    if (currentChannels.includes(channel)) {
      setFieldValue(
        "channels",
        currentChannels.filter((c) => c !== channel),
      );
    } else {
      setFieldValue("channels", [...currentChannels, channel]);
    }
  };

  const isChannelSelected = (channel: AlertChannel) => {
    return values.channels?.includes(channel) || false;
  };

  const hasError = Boolean(touched?.channels && errors?.channels);

  return (
    <FormControl isRequired isInvalid={hasError}>
      <FormLabel color="#414651" fontWeight={"500"}>
        {t("deliveryChannel")}
      </FormLabel>
      <Flex gap={4} wrap="wrap">
        <CustomCheckboxCard
          value="whatsapp"
          label="WhatsApp"
          icon={whatsappBlue}
          isChecked={isChannelSelected("whatsapp")}
          onClick={() => handleChannelToggle("whatsapp")}
        />
        <CustomCheckboxCard
          value="email"
          label="Email"
          icon={Mail}
          isChecked={isChannelSelected("email")}
          onClick={() => handleChannelToggle("email")}
        />
        <CustomCheckboxCard
          value="push_notification"
          label="App"
          icon={Smartphone}
          isChecked={isChannelSelected("push_notification")}
          onClick={() => handleChannelToggle("push_notification")}
        />
      </Flex>
      {hasError && (
        <FormErrorMessage>{t("atLeastOneChannelRequired")}</FormErrorMessage>
      )}
    </FormControl>
  );
};
